import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html,body{
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        font-family: 'Nexus-Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        scroll-behavior: smooth;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    * {
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }
    a {
        color: inherit;
        text-decoration: none;
    }
`;

export default GlobalStyle;
